let Cookies = require('js-cookie');
import { cookie } from '@/utils';

if (Cookies) {
	Cookies = Cookies.withAttributes({ sameSite: 'lax', domain: process.env.VUE_APP_API_HOST || '.gravityfox.com' });
}

class Cookie {
	static get(key, request = null) {
		if (request) {
			return cookie.get(request, key);
		}

		return Cookies ? Cookies.get(key) : null;
	}

	static getJSON(key, request = null) {
		if (request) {
			return cookie.getJSON(request, key);
		}

		if (!Cookie) {
			return null;
		}

		let value = Cookies.get(key);
		try {
			let json = JSON.parse(value);
			value = json;
		} catch (e) {}

		return value;
	}

	static set(key, value, options) {
		if (Cookies) {
			try {
				if (typeof value !== 'string') {
					let json = JSON.stringify(value);
					value = json;
				}
			} catch (e) {}

			Cookies.set(key, value, { expires: options.expires || 360 });
			return true;
		}

		return false;
		// TODO - Ensure cookies set on server side are applying to client side
		// if (process.server && options.res) {
		// 	res.setHeader('Set-Cookie', '=')
		// }
	}

	static remove(key) {
		if (Cookies) {
			Cookies.remove(key);
		}
	}

	/**
	 * Remove all cookies
	 */
	static clear() {
		if (Cookies) {
			Object.keys(Cookies.get()).forEach(function(cookie) {
				Cookies.remove(cookie);
			});
		}
	}
}

export default Cookie;
